__turbopack_context__.v({
  "fadeUp": "BRAZdq_fadeUp",
  "grid": "BRAZdq_grid",
  "iconImage": "BRAZdq_iconImage",
  "iconWrapper": "BRAZdq_iconWrapper",
  "inner": "BRAZdq_inner",
  "item": "BRAZdq_item",
  "itemCaption": "BRAZdq_itemCaption",
  "itemTitle": "BRAZdq_itemTitle",
  "muteButton": "BRAZdq_muteButton",
  "placeholderInside": "BRAZdq_placeholderInside",
  "section": "BRAZdq_section",
  "textStack": "BRAZdq_textStack",
  "title": "BRAZdq_title",
  "video": "BRAZdq_video",
  "videoFrame": "BRAZdq_videoFrame",
});
